{
  "zh-TW": {
    "modelPicker": {
      "hangarTitle": "將艦船加入你的機庫",
      "compareTitle": "選擇要比較的飛船",
      "wishlistTitle": "將艦船加入你的願望清單",
      "labels": {
        "search": "依名稱或製造商搜尋",
        "results": "%{count} 艘艦船",
        "selected": "已選擇 %{count} 艘"
      },
      "actions": {
        "resetFilters": "重設篩選",
        "clearSelection": "清除選擇",
        "increase": "再加入一艘 %{name}",
        "decrease": "移除一艘 %{name}"
      },
      "badges": {
        "inHangar": "已在機庫",
        "onWishlist": "已在願望清單",
        "comparing": "比較中"
      }
    }
  }
}
